


















import { Component, Vue, Prop } from 'vue-property-decorator';
import { format5DigitsVariant } from '@/utils/numbers';
import { IMBALANCE_ALARM_LIMIT } from "@/constants";
import {getImbalanceStyleColor} from "@/utils/getImbalanceStyleColor";

@Component({
  name: 'NebalansCell',
  components: {
  }
})
export default class extends Vue {
  @Prop() public data!: number | null;
  @Prop() public title!: string;
  @Prop() public colorKey!: string;

  private format5Digits = new Intl.NumberFormat('ru-RU', {style: 'decimal', maximumFractionDigits: 5});
  private format5DigitsFraction = new Intl.NumberFormat('ru-RU', {style: 'decimal', minimumFractionDigits: 5, maximumFractionDigits: 5})

  public checkImbalanceHighlight(value: number | null): string {
    return getImbalanceStyleColor(this.colorKey, this.data);
  }

  public formatValue(val: number | null) {
    if (typeof(val) === 'number') {
      if (val % 1 != 0) {
        const digits =  val.toString().split('.').pop();
        if (digits && digits.length <= 5) {
          return this.format5Digits.format(val);
        }
        return this.format5DigitsFraction.format(val);
      } else if (val != 0) {
        return val
      } else {
        return 0
      }
    }
  }

  public formatTitle(val: number | null) {
    if (typeof(val) === 'number') {
      return format5DigitsVariant.format(val)
    }
    return ""
  }
}
